const isCurrent = (path, current, index) => {
  const pathList = path.split('/');
  const currentList = current.split('/');
  return pathList[pathList.length - 1] === currentList[index];
};

export default isCurrent;